import React from "react";
const About = () => {
  const info = [
    { text: "Years experience", count: "03" },
    { text: "Completed Real World Projects", count: "12" },
    { text: "Companies Work", count: "02" },
  ];
  return (
    <section id="about" className="py-5 text-white">
      <div className="text-center mt-8">
        <h3 className="text-5xl font-semibold">
          About <span className="text-cyan-600">Me</span>
        </h3>
        <p className="text-gray-400 my-3 text-lg">My introduction</p>
        <div className="flex items-center justify-center max-w-6xl mx-auto">
          <div className="p-2">
            <div className="text-gray-300 my-3">
              <p className="text-justify leading-10 text-lg w-11/12 mx-auto">
                I am Usman Mughal, a passionate and self-taught professional web
                developer dedicated to delivering exceptional results. My
                specialization lies in the MERN stack, allowing me to create
                dynamic websites, APIs with intricate logic, and captivating
                landing pages. My code primarily revolves around
                JavaScript/Typescript, ensuring robust and efficient solutions.
                With a rich experience spanning over three years, I take pride in
                surpassing the level of work typically expected from a ten-year
                experienced developer. I prioritize quality, and my optimized
                approaches ensure timely delivery of projects.
              </p>
              <div className="flex justify-center mt-10 mx-auto text-center items-center gap-7">
                {info.map((content) => (
                  <div key={content.text}>
                    <h3 className="md:text-4xl text-2xl font-semibold text-white">
                      {content.count}
                      <span className="text-cyan-600">+</span>{" "}
                    </h3>
                    <span className="md:text-base text-xs">{content.text}</span>
                  </div>
                ))}
              </div>
              <br />
              <br />
              {/* <a href="./src/assets/Code_a_program.pdf" download>
                <button className="btn-primary">Download CV</button>
              </a> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
